<script setup lang="ts">
import { share, calendar, location, pencil } from "ionicons/icons";
import { useAppStore } from "@/stores/app";
import { useContextStore } from "@/stores/context";
import { computed } from "vue";

import {
  IonIcon,
  IonContent,
  IonPage,
  IonGrid,
  IonLabel,
  IonItem,
  IonRow,
  IonCol,
} from "@ionic/vue";
import EventSidebar from "@/views/_partials/EventSidebar.vue";
import useDates from "@/composition/dates";
import { useWindowWidth } from "@/composition/window";

const { isMobile } = useWindowWidth();
const contextStore = useContextStore();
const appStore = useAppStore();

const dates = useDates();
import router from "@/router";

const seeVisitors = (type: string) => {
  switch (type) {
    case "all":
      router.push(`/event/${contextStore.event.id}/visitors`);
      break;
    case "checked-in":
      router.push(`/event/${contextStore.event.id}/visitors/checkedin`);
      break;
    default:
      router.push(`/event/${contextStore.event.id}/visitors`);
  }
};

const dark_mode = computed(() => appStore.settings.theme === "dark");

</script>
<template>
  <ion-page>
    <ion-content>
      <div class="flex-desktop">
        <event-sidebar v-if="!isMobile" :event="contextStore.event" />
        <div :class="dark_mode ? 'full-width' : 'colored-bg full-width'">
          <section :class="dark_mode ? 'dark_mode' : ''">
            <div class="container">
              <h1>
                {{ contextStore.event.name }}
                <router-link
                  style="color: var(--color)"
                  :to="`/event/${contextStore.event.id}/settings`"
                >
                  <small>
                    <ion-icon :icon="pencil" class="ion-float-right" />
                  </small>
                </router-link>
              </h1>

              <h4>
                Attendance Status:
                <b class="ion-float-right"
                  >{{
                    contextStore.event.checked_in_visitors > 0
                      ? Math.round(
                          (contextStore.event.checked_in_visitors /
                            contextStore.event.registered_visitors) *
                            100
                        )
                      : 0
                  }}%</b
                >
              </h4>
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <div
                      class="box ion-margin-bottom clickable"
                      @click="seeVisitors('all')"
                    >
                      <h1 class="dark">
                        {{ contextStore.event.registered_visitors }}
                      </h1>
                    </div>
                    <p>Total Visitors</p>
                  </ion-col>
                  <ion-col>
                    <div
                      class="box is-success ion-margin-bottom clickable"
                      @click="seeVisitors('checked-in')"
                    >
                      <h1>{{ contextStore.event.checked_in_visitors }}</h1>
                    </div>
                    <p>Entered</p>
                  </ion-col>
                </ion-row>
              </ion-grid>
              <h4>When and where <ion-icon :icon="share" /></h4>
              <ion-item>
                <ion-icon :icon="calendar" />
                <ion-label>
                  <h5>Date and time</h5>
                  <p>
                    Starts at
                    {{ dates.getDateWithTime(contextStore.event.start_date) }}
                  </p>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-icon :icon="location" />
                <ion-label>
                  <h5>Location</h5>
                  <p>{{ contextStore.event.location }}</p>
                </ion-label>
              </ion-item>
              <template v-if="contextStore.event.description !== ''">
                <h4>About this event</h4>
                <p v-html="contextStore.event.description"></p>
              </template>
            </div>
          </section>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss" scoped>
figure {
  margin: 0;
  position: relative;
  ion-icon {
    position: absolute;
    font-size: 1.25rem;
    top: 1rem;
    right: 1rem;
  }
}
.box {
  h1 {
    margin: 0.5rem 0;
  }
}
ion-item {
  --inner-padding-end: 0;
  --inner-padding-start: 0;
  padding: 0;
  ion-icon {
    margin-right: 0.5rem;
  }
}
.clickable {
  cursor: pointer;
}

.dark_mode {
  background: #121212;
}

@media (min-width: 768px) {
  .colored-bg.full-width {
    overflow-y: auto;
    height: calc(100vh - 72px);
  }
}
</style>
